import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import theme from '../theme.css';

const useStyles = makeStyles((theme) => ({
    sumary: {
        "& .MuiAccordionSummary-root": {
            margin: 0,
            "& .Mui-expanded": {
                margin: 0,
            }
        },
        height: 'auto',
        "& .MuiAccordionSummary-contentGutters": {
            margin: 0,
            "&.Mui-expanded":{
                margin: 0,
            }
        }
    },
    details: {
        textAlign: 'left',
    },
}));

export default function CustomAccordion(props){
    const classes = useStyles();
    const {icon, sumary, details} = props;

    return (
        <Accordion classes={{
            root: classes.root,
        }}
        sx={{
            backgroundColor: theme.palette.common.white,
            border: 'none',
            boxShadow: 'none',
        }}
        >
            <AccordionSummary
                expandIcon={icon ? icon : null}
                aria-controls="panel1a-content"
                id="panel1a-header"
                classes={{
                    root: classes.sumary
                }}
            >
                <Typography variant='subtitle1' color='primary'>{sumary}</Typography>
            </AccordionSummary>
            <AccordionDetails 
                classes={{
                    root: classes.details
                }}
            >
                {details}
            </AccordionDetails>
        </Accordion>
    );
}